// src/pages/CategoryPage.jsx
import { useParams, Link } from "react-router-dom";
import Seo from "../components/Seo"; // the helper we created earlier

const CATS = {
  electrical: {
    name: "Electrical",
    description:
      "Automation products, cable management, lighting, control & switchgear, motors and more.",
  },
  "site-safety": {
    name: "Site Safety",
    description:
      "Signage, spill containment, eyewash, height safety, lockout and marine safety.",
  },
  "power-air": {
    name: "Power/Air",
    description:
      "Air tools, batteries, chargers, generators, inverters and power supplies.",
  },
  industrial: {
    name: "Industrial",
    description:
      "Abrasives, fasteners, paints, lubricants, pipe fittings, pumps/valves and storage.",
  },
  ppe: {
    name: "PPE",
    description:
      "Workwear, protective footwear/headwear, eye/face/hearing/respiratory/sun protection.",
  },
  "hand-tools": {
    name: "Hand Tools",
    description:
      "Sockets, wrenches, pliers, hammers, drivers, measuring, tool bags and chests.",
  },
  mechanical: {
    name: "Mechanical",
    description:
      "Fabrication and hydraulics gear for workshops and field service.",
  },
  mining: {
    name: "Mining",
    description:
      "Exploration, open pit and underground essentials, processing and wear solutions.",
  },
  // "uniforms-workwear": {
  //   name: "Uniforms & Workwear",
  //   description:
  //     "Boots, jackets, overalls, pants and shirts for industrial environments.",
  // },
};

export default function CategoryPage() {
  const { slug } = useParams();
  const cat = CATS[slug];

  if (!cat) {
    // unknown slug: show 404-style page, but noindex it
    return (
      <>
        <Seo
          title="Category Not Found"
          noindex
          canonicalPath={`/categories/${slug}/`}
        />
        <h1>Category Not Found</h1>
      </>
    );
  }

  const urlPath = `/categories/${slug}/`;
  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: `${cat.name} — CTL AUSTRALIA`,
    url: `https://www.ctlaus.com${urlPath}`,
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.ctlaus.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: cat.name,
          item: `https://www.ctlaus.com${urlPath}`,
        },
      ],
    },
  };

  return (
    <>
      <Seo
        title={cat.name}
        description={cat.description}
        canonicalPath={urlPath}
        schema={schema}
      />
      <h1>{cat.name}</h1>
      <p>{cat.description}</p>
      {/* TODO: render the actual products for this category */}
      <p>
        <Link to="/product-list">Browse all products</Link>
      </p>
    </>
  );
}
